import React from 'react';
import { Search } from 'lucide-react';
import FacturationListPageLayout from '../../facturation/components/FacturationListPageLayout';
import FacturationViewModeToggle from '../../facturation/components/FacturationViewModeToggle';
import { buildVentesImportExportProps } from '../ventesListPageUtils';

export { facturationTableScrollClass } from '../../facturation/components/FacturationListPageLayout';

/**
 * Ventes list chrome — thin wrapper around FacturationListPageLayout
 * (Products-style Qawaem: bulk delete · search · 4 KPIs · import/export).
 */
export default function VentesListPageChrome({
  t,
  p,
  qawaem,
  isDashboardLightMode,
  title,
  subtitle,
  icon,
  listStats,
  viewMode,
  onViewModeChange,
  filterActions = null,
  searchTerm,
  onSearchChange,
  searchPlaceholder,
  onCreate,
  createLabel,
  importExportState,
  importExportHandlers,
  isGeneratingPDF,
  showAdvancedOptions,
  onToggleAdvancedOptions,
  advancedOptionsLabel,
  advancedOptionsContent,
  extraHeaderActions = null,
  beforeTable = null,
  children,
}) {
  const importExportProps = buildVentesImportExportProps({
    ...importExportState,
    p,
    t,
    isGeneratingPDF,
    handlers: importExportHandlers,
  });

  return (
    <FacturationListPageLayout
      title={title}
      subtitle={subtitle}
      icon={icon}
      stats={listStats}
      viewMode={viewMode}
      onViewModeChange={onViewModeChange}
      filterActions={filterActions}
      searchTerm={searchTerm}
      onSearchChange={onSearchChange}
      searchPlaceholder={searchPlaceholder}
      onCreate={onCreate}
      createLabel={createLabel}
      importExport={importExportProps}
      headerActions={extraHeaderActions}
      showAdvancedOptions={showAdvancedOptions}
      onToggleAdvancedOptions={onToggleAdvancedOptions}
      advancedOptionsLabel={advancedOptionsLabel}
      advancedOptionsContent={advancedOptionsContent}
      controlsStrip={
        !qawaem ? (
          <div className="facturation-list-controls-strip p-4 border-b border-white/10">
            <div className="facturation-list-controls-row flex min-w-0 flex-row flex-wrap items-center gap-2 lg:gap-4">
              {viewMode === 'cards' ? (
                <div className="relative min-w-0 flex-1 max-w-md">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-white/50" />
                  <input
                    type="text"
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 bg-white/10 border border-white/20 rounded-xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              ) : null}
              <FacturationViewModeToggle
                viewMode={viewMode}
                onViewModeChange={onViewModeChange}
                isLight={isDashboardLightMode}
                cardsTitle={t('common.view_cards')}
                tableTitle={t('common.view_table')}
              />
            </div>
          </div>
        ) : null
      }
    >
      {beforeTable}
      {children}
    </FacturationListPageLayout>
  );
}
